import React from 'react';
import { Comment as AntComment } from "antd";
import { omit } from 'lodash';
import './Comment.less';
export default class Comment extends AntComment {

    render() {
        const { className } = this.props;
        const props = omit(this.props, ['className'])
        return (
            <AntComment {...props} className={`hms-comment ${className || ''}`}>{this.props.children}</AntComment>
        )
    }
}